import classNames from 'classnames';
import PropTypes from 'prop-types';
import MobileIslandActionIsland from './MobileIslandActionIsland';

const renderMiddleSlot = (middle, middleAriaLabel) => {
	if (!middle) {
		return null;
	}

	return (
		<div className='app-mobile-action-island-dock__middle'>
			<MobileIslandActionIsland ariaLabel={middleAriaLabel} scrollHint>
				{middle}
			</MobileIslandActionIsland>
		</div>
	);
};

/** 默认一行三岛；搜索展开时上排操作岛全宽，下排 lead · 搜索与上排同宽对齐 */
const MobileIslandDockLayout = ({ searchExpanded, searchFocused, lead, middle, middleAriaLabel = '页面操作', search }) => {
	const middleSlot = renderMiddleSlot(middle, middleAriaLabel);
	const showActionsRow = Boolean(searchExpanded && middleSlot);

	return (
		<div
			className={classNames('app-mobile-action-island-dock', {
				'app-mobile-action-island-dock--search-expanded': searchExpanded,
				'app-mobile-action-island-dock--search-focused': searchExpanded && searchFocused,
				'app-mobile-action-island-dock--no-middle': !middle,
				'app-mobile-action-island-dock--no-search': !search,
			})}
		>
			{showActionsRow ? <div className='app-mobile-action-island-dock__actions-row'>{middleSlot}</div> : null}

			<div className='app-mobile-action-island-dock__base-row'>
				<div className='app-mobile-action-island-dock__lead'>{lead}</div>
				{!searchExpanded ? middleSlot : null}
				{search ? <div className='app-mobile-action-island-dock__search'>{search}</div> : null}
			</div>
		</div>
	);
};

MobileIslandDockLayout.propTypes = {
	searchExpanded: PropTypes.bool,
	searchFocused: PropTypes.bool,
	lead: PropTypes.node,
	middle: PropTypes.node,
	middleAriaLabel: PropTypes.string,
	search: PropTypes.node,
};

export default MobileIslandDockLayout;
